__turbopack_context__.v({
  "alt": "Zgok1G_alt",
  "caption": "Zgok1G_caption",
  "figure": "Zgok1G_figure",
});
